export enum UsersChannel {
  CREATE = 'users::create',
  EDIT = 'users::patch',
  DELETE = 'users::delete',
}
